import axios from 'axios'
const state = {
    actions: [],
};

const getters = {
    getActions: (state) => state.actions,
    hasPermission: state => rrn => state.actions.includes(rrn)
};

const actions = {
    getActions({ commit }) {
        console.log("getactions - calling /permissions/mine")
        console.log("axios.defaults.baseURL:", axios.defaults.baseURL)
        axios.get('/permissions/mine')
            .then(resp => {
                console.log("permissions/mine response:", resp.data)
                commit('SET_ACTIONS', resp.data)
            }).catch(err => {
                console.error("permissions/mine error:", err)
                console.error("Request URL:", err.config?.url)
                console.error("Base URL:", err.config?.baseURL)
            })
    },
    setActions({ commit }, actions) {
        commit('SET_ACTIONS', actions)
    },
    hasPermission({ state }, permission) {
        console.log("haspermission")
        return state.actions.find(action => action.rrn == permission)
    }
};

const mutations = {
    SET_ACTIONS(state, actions) {
        state.actions = actions
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};